// 버전 정보를 동적으로 가져오기
export const getServerVersionInfo = async () => {
    try {
        // version.json 파일에서 버전 정보 가져오기
        const response = await fetch('/version.json', {
            cache: 'no-cache',
            headers: {
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                Pragma: 'no-cache',
            },
        });
        if (response.ok) {
            const versionData = await response.json();
            return {
                ...versionData,
                source: 'file',
            };
        }
        // 기본값 반환
        return {
            version: 'unknown',
            buildTime: new Date().toISOString(),
            source: 'default',
        };
    } catch (error) {
        console.warn('버전 정보를 가져올 수 없습니다:', error);
        return {
            version: 'unknown',
            buildTime: new Date().toISOString(),
            source: 'error',
        };
    }
};

// 버전을 저장하는 함수
export const setVersion = version => {
    localStorage.setItem('currentVersion', version);
};

// 버전 정보를 가져오는 함수
export const getVersion = () => {
    const version = localStorage.getItem('currentVersion');
    if (!version || version.length !== 16) {
        return null;
    }
    return version.toString();
};

// 버전을 읽기 쉬운 형식으로 포맷팅
export const getDisplayVersion = () => {
    const version = getVersion();

    // 14자리 숫자를 일반적인 버전 형태로 변환
    if (version) {
        const part1 = version.slice(0, 4);
        const part2 = version.slice(4, 8);
        const part3 = version.slice(8, 12);
        const part4 = version.slice(12, 16);

        return `V-${part1}-${part2}-${part3}-${part4}`;
    }

    return 'unknown';
};

// 버전 체크 및 리로드
export const checkVersionAndReload = async () => {
    try {
        const versionInfo = await getServerVersionInfo();
        if (!versionInfo || versionInfo.version === 'unknown') {
            console.log('VersionChecker: 버전 정보를 가져올 수 없습니다.');
            return;
        }

        const currentVersion = getVersion();
        const serverVersion = versionInfo.version.toString();

        if (!currentVersion) {
            //console.log('VersionChecker: 버전 저장:', versionInfo.version);
            setVersion(serverVersion);
            return;
        }

        // 서버 버전 비교
        if (currentVersion !== serverVersion) {
            //console.log('VersionChecker: 버전이 변경됨 - 이전버전:' + currentVersion + ' 새버전:' + serverVersion);

            // 새 버전 저장
            setVersion(serverVersion);

            // 페이지 리로드
            if (window.ReactNativeWebView) {
                window.location.reload();
                /*      
                window.ReactNativeWebView.postMessage(JSON.stringify({
                    type: 'reload',
                }));
                */
            } else {
                window.location.reload();
            }
        }
    } catch (error) {
        console.error('VersionChecker: 버전 체크 중 오류:', error);
    }
};
